import './App.scss';
import { BrowserRouter } from 'react-router-dom';

import HubRoutes from "./routes";

import AuthProvider from './context/authContext';
import ToastProvider from "./context/toastContext";
import HubToast from './components/toast';
import LoaderProvider from './context/loaderContext';
import HubLoader from './components/loader';
import FooterProvider from './context/footerContext';
import NewVersionProvider from "./context/newVersionContext";
import NewVersionModal from './components/modals/newVersionModal';
import { useLayoutEffect, useState } from 'react';
import { AuthenticatedRoutes, ManufacturerRoutes } from './routes/AppRoutes';







function App() {
  const [checkForRoute, isRedirectNecessary] = useState<boolean>(false)

  useLayoutEffect(() => {
    if (!localStorage.getItem("token")) {
      if (
        window.location.pathname === "/" ||
        [...ManufacturerRoutes, ...AuthenticatedRoutes].find((route) => route.route === window.location.pathname)
      ) {
        const redirect_url = process.env.REACT_APP_PUBLIC_REDIRECT_URL
        if (redirect_url) window.location.replace(redirect_url)
      } else
        isRedirectNecessary(true)
    } else {
      isRedirectNecessary(true)
    }
  }, [])

  return (
    <AuthProvider>
      <ToastProvider>
        <LoaderProvider>
          <FooterProvider>
            <NewVersionProvider>
              {checkForRoute ? (
                <>
                  <BrowserRouter>
                    <HubRoutes />
                  </BrowserRouter>

                  <HubToast />
                  <HubLoader />
                  <NewVersionModal />
                </>
              ) : <></>}
            </NewVersionProvider>
          </FooterProvider>
        </LoaderProvider>
      </ToastProvider>
    </AuthProvider>
  );
};

export default App;
